import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconEllipsisComponent } from "./med-icon-ellipsis.component";

@NgModule({
  declarations: [
    MedIconEllipsisComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconEllipsisComponent,
  ],
})
export class MedIconEllipsisModule { }
